var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9999 12H6.99976",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6666 17L36.7467 30.7982C36.3927 36.108 36.2157 38.763 34.4857 40.3815C32.7557 42 30.0949 42 24.7733 42H23.2266C17.905 42 15.2441 42 13.5141 40.3815C11.7841 38.763 11.6071 36.108 11.2531 30.7982L10.3333 17",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 22L20 32",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22L28 32",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12C13.1118 12 13.1676 12 13.2183 11.9987C14.8652 11.957 16.318 10.9098 16.8784 9.36064C16.8957 9.31299 16.9133 9.25997 16.9487 9.15395L17.1429 8.57143C17.3086 8.07416 17.3915 7.82551 17.5014 7.6144C17.94 6.77214 18.7515 6.18727 19.6892 6.03753C19.9243 6 20.1863 6 20.7105 6H27.2895C27.8137 6 28.0757 6 28.3108 6.03753C29.2485 6.18727 30.06 6.77214 30.4986 7.6144C30.6085 7.82551 30.6914 8.07415 30.8571 8.57143L31.0513 9.15395C31.0866 9.25983 31.1043 9.31302 31.1216 9.36064C31.682 10.9098 33.1348 11.957 34.7817 11.9987C34.8324 12 34.8882 12 35 12",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.728e47b165db2969e209305683b64172.svg";
export { ForwardRef as ReactComponent };